<template>
  <b-container fluid class="d-flex">
    <radio-stat-box v-for="(option, index) in options"
                    size="x-small"
                    :label="option.label"
                    :value="option.value"
                    :radio-name="option.formName"
                    :radio-value="option.formValue"
                    :radio-model="model"
                    @change="handleChange"
                    :divider="index !== (options.length - 1)"
    />
  </b-container>

</template>

<script>
import RadioStatBox from '@/components/Dashboard/RadioStatBox';

export default {
  name: "RadioStatPanel",
  components: {
    RadioStatBox,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      model: 0,
    }
  },

  methods: {
    handleChange(event) {
      this.$emit('change', event.value);
    },
  }
}
</script>

<style scoped>

</style>
